/**
 * @description Значение шаблон.
 * @type {string}
 */
const TEMPLATE_VALUE = 'template';

/**
 * @description Значение категории.
 * @type {string}
 */
const CATEGORY_VALUE = 'category';

/**
 * @description Примись формы добавления элементов шаблона плана лечения.
 */
export default {
  computed: {
    /**
     * @description Выбрана категория.
     * @returns {boolean}
     */
    isSelectedCategory() {
      return this.selectedType === CATEGORY_VALUE;
    },
    /**
     * @description Выбран шаблон.
     * @returns {boolean}
     */
    isSelectedTemplate() {
      return this.selectedType === TEMPLATE_VALUE;
    },
  },
  data() {
    return {
      /**
       * @description Типы элемента
       * @type {Array}
       */
      itemTypes: [
        {
          title: 'Категория',
          value: CATEGORY_VALUE,
        },
        {
          title: 'Шаблон',
          value: TEMPLATE_VALUE,
        },
      ],
      /**
       * @description Выбранный тип элемента
       * @type string
       */
      selectedType: CATEGORY_VALUE,
    };
  },
};
